<template>
  <div class="clue-list">
    <div class="table-box">
      <div class="table-header">
        <div class="th">国家</div>
        <div class="th">产品名称</div>
        <div class="th">平台</div>
        <div class="th">访问时间</div>
      </div>
      <div class="table-content">
        <div class="row" v-for="(item, index) in clueList" :key="index">
          <div class="td">{{ item.country_name }}</div>
          <div class="td">{{ item.product_name }}</div>
          <div class="td">{{ item.channel }}</div>
          <div class="td">{{ item.visit_time }}</div>
        </div>
      </div>
    </div>
    <div class="nodata" v-if="clueList.length === 0">暂无数据</div>
  </div>
</template>

<script>
import QiyuService from '../../services/qiyuService';
import toast from '../../services/toast.js';

export default {
  name: '',
  components: {},
  data() {
    return {
      activityService: new QiyuService(this.$http),
      user_account_id: 0,
      clueList: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.user_account_id = +this.$route.query.user_account_id || 0;
    if (!this.user_account_id) {
      toast.show('无用户ID，无法查询数据');
      return;
    }
    this.getClueList();
  },
  methods: {
    getClueList() {
      this.activityService.getClueList(this.user_account_id).then((data) => {
        if (data && data.body && data.body.body) {
          this.clueList = data.body.body.page_data;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.clue-list {
  width: 100%;
  min-height: 100%;
  background: #fff;
  padding: 12px;
  box-sizing: border-box;
  .table-box {
    border: 1px solid #f2f3f5;
    .th,
    .td {
      padding: 12px 6px;
      font-size: 14px;
      line-height: 20px;
      word-break: break-all;
      color: #222222;
      &:nth-child(1) {
        width: 42px;
        flex-grow: 1;
        flex-shrink: 0;
      }
      &:nth-child(2) {
        width: 96px;
        flex-grow: 4;
        flex-shrink: 1;
      }
      &:nth-child(3) {
        width: 42px;
        flex-grow: 1;
        flex-shrink: 0;
      }
      &:nth-child(4) {
        width: 85px;
        flex-grow: 2;
        flex-shrink: 1;
      }
    }
    .table-header {
      background: #f2f3f5;
      border-bottom: 1px solid #e9e9e9;
      display: flex;
      .th {
        font-weight: 600;
      }
    }

    .table-content {
      .row {
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .nodata {
    color: #999;
    margin-top: 10px;
    text-align: center;
  }
}
</style>
